import React, {useCallback, useState} from 'react';
import {fetchMachineAssignmentHistory} from 'web/redux/actions/MachineActions';
import {showMessage} from 'web/utils/modalHelper';

/**
 *
 */
export default function useAssignmentHistory({dispatch}) {
  const [histories, setHistories] = useState([]);
  const getStates = (getter) => {
    if (typeof getter === 'function') {
      return getter({histories, setHistories});
    };
  };
  const fetchBindingHistories = useCallback(async (id) => {
    setHistories([]);
    try {
      const res = await dispatch(
        fetchMachineAssignmentHistory({id, type: 'create,delete'}),
      );
      if (!res?.payload?.code?.isSuccessCode()) {
        return;
      }

      setHistories(res.payload.result);
    } catch (error) {
      showMessage('error', error);
      console.error('fetch machine assignment history error', error);
    }
  });
  return {fetchBindingHistories, getStates};
}
